import service from "@irati/utils/tracking/index";
var tracking = {
    changeTagVisibility: function (tag, newValue) {
        var data = {
            tag_id: tag.uuid,
            tag_new_value: newValue,
            tag_name: tag.name
        };
        service.trackEvent("admin_change_perks_tag_visibility", data);
    },
    changePerkVisibility: function (perk, newValue) {
        var data = {
            perk_id: perk.uuid,
            perk_new_value: newValue,
            perk_name: perk.header
        };
        service.trackEvent("admin_change_perk_visibility", data);
    },
    createTeam: function (teamName) {
        var data = { team_name: teamName };
        service.trackEvent("admin_create_team", data);
    },
    startCreateUser: function (createType) {
        switch (createType) {
            case "add_people-single":
                service.trackEvent("admin_start_create_user");
                break;
            case "add_people-multiple":
                service.trackEvent("admin_start_create_users");
                break;
            default:
                return null;
        }
    },
    createUser: function (access, teams) {
        var data = {
            access_level: access,
            team: teams
        };
        service.trackEvent("admin_create_user", data);
    },
    createUsers: function () {
        service.trackEvent("admin_create_users");
    },
    startEnableSSO: function () {
        service.trackEvent("admin_start_enable_sso");
    },
    enableSSO: function () {
        service.trackEvent("admin_enable_sso");
    },
    enableSSU: function () {
        service.trackEvent("admin_enable_ssu");
    },
    updateWelcomeEmail: function () {
        service.trackEvent("admin_update_welcome_email");
    },
    updateLogo: function () {
        service.trackEvent("admin_update_logo");
    },
    updateColorScheme: function () {
        service.trackEvent("admin_update_colour_scheme");
    },
    viewReportingPerks: function () {
        service.trackEvent("admin_view_reporting_perks");
    },
    viewReportingPlatform: function () {
        service.trackEvent("admin_view_reporting_platform");
    },
    viewReportingRewards: function () {
        service.trackEvent("admin_view_reporting_rewards");
    },
    downloadRewardLog: function () {
        service.trackEvent("admin_download_rewards");
    },
    editUserExternalID: function (userId) {
        var data = {
            userId: userId
        };
        service.trackEvent("admin_edit_external_id", data);
    },
    viewHelp: function () {
        service.trackEvent("admin_view_help");
    },
    viewTrainingWebinars: function () {
        service.trackEvent("admin_view_training_webinars");
    },
    viewLaunchingPerkbox: function () {
        service.trackEvent("admin_view_launching_perkbox");
    },
    viewCustomisation: function () {
        service.trackEvent("admin_view_customisation");
    },
    viewPeopleManagement: function () {
        service.trackEvent("admin_view_people_management");
    },
    viewBillingPayments: function () {
        service.trackEvent("admin_view_billing_payments");
    }
};
export default tracking;
